import { List, Grid, Chip, Avatar } from "@mui/material"
import { useAppSelector } from "../../../../../../../hooks/store-hooks";
import { theme } from "../../../../../../../styles";
import { useProjetosService } from "../../../../../../../../use-cases/geo-veles";

export const EscolaridadesFilterPreview = () => {
  // State
  const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
  // Hook
  const { removeEscolaridadeFilter } = useProjetosService()

  return (
    <>
      <List>
        <Grid container spacing={3}>
          {filtrosSelecionados?.escolaridade?.map((escolaridade, index) => {
            return (
              <Grid item key={index}>
                <Chip
                  label={escolaridade.toUpperCase()}
                  sx={{
                    height: 'auto',
                    '& .MuiChip-label': {
                      transition: '0.1s all',
                      display: 'block',
                      whiteSpace: 'normal',
                      padding: '10px 15px',
                      fontWeight: 'bold'
                    }
                  }}
                  color="primary"
                  onDelete={() => {
                    removeEscolaridadeFilter(escolaridade)
                  }}
                  avatar={
                    <Avatar
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText
                      }}
                    >
                    </Avatar>
                  }
                />
              </Grid>
            )
          })}
        </Grid>
      </List >
    </>
  )
}